import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangeRequestPreviewComponent } from './change-request-preview.component';
import { ProjectsResolverService } from 'app/resolvers/projects-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: ChangeRequestPreviewComponent,
    // resolve: {
    //   projects: ProjectsResolverService
    // }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangeRequestPreviewRoutingModule { }
